import { Navigate, Route, Routes } from 'react-router-dom';
import AdminRoute from 'enums/adminRoutes';
import PublicRoute from 'enums/publicRoutes';
import TransactionListPage from 'admin/pages/Transactions/TransactionListPage';
import QualityMarkListPage from 'admin/pages/QualityMarks/QualidtyMarkListPage';
import EShopEmailListPage from '../../pages/EShopEmailListPage';
import FarmEmailListPage from '../../pages/FarmEmailListPage';
import ContractListPage from '../../pages/Contracts/ContractListPage';
import OrderListPage from '../../pages/Orders/OrderListPage';
import FarmListPage from '../../pages/Farms/FarmListPage';
import UserListPage from '../../pages/Users/UserListPage';
import PermissionListPage from '../../pages/Users/PermissionListPage';
import { Products } from '../../pages/Products';
import ProtectedRoute from '../../../public/components/DefaultLayout/ProtectedRoutes/ProtectedRoute';
import { default as FarmOwnerTransactionListPage } from '../../pages/Transactions/FarmOwnerTransactionListPage';
import { BannersPage } from '../../pages/Banners';
import { FarmContracts } from '../../pages/FarmContracts/FarmContracts';
import SettingListPage from '../../pages/Settings/SettingListPage';
import FarmSettingListPage from '../../pages/Settings/FarmSettingListPage';
import EmarketSettingListPage from '../../pages/Settings/EmarketSettingListPage';
import { PartnersPage } from '../../pages/PartnersPage/PartnersPage';
import { BusinessInformation } from '../../pages/BusinessInformation';
import Pages from '../../pages/Pages';
import NotificationListPage from '../../pages/Notifications/NotificationsPage';
import CouponsPage from '../../pages/Coupons';
import QualityMarksSync from 'admin/pages/QualityMarksSync';
import { ListingsPage } from '../../pages/Listings/ListingsPage';
import { ListingApplicationsPage } from '../../pages/Listings/ListingApplicationsPage';
import { ChatPage } from '../../pages/Chat/ChatPage';
import ClassifiersPage from 'admin/pages/Classifiers';
import FarmUserListPage from '../../pages/Users/FarmUserListPage';
import { permissions } from '../../../config/config';
import { FarmDeliveriesPage } from 'admin/pages/FarmDeliveriesPage';

const Router = () => {
  const renderRoutes = () => {
    return (
      <>
        <Route
          path={AdminRoute.PARTNERS}
          element={
            <ProtectedRoute children={<PartnersPage />} requiresFarmAdmin />
          }
        />

        <Route
          path={AdminRoute.LISTINGS}
          element={
            <ProtectedRoute
              children={<ListingsPage />}
              requiresFarmAdmin
              requiresWholesaleContract
            />
          }
        />

        <Route
          path={AdminRoute.LISTING_APPLICATIONS}
          element={
            <ProtectedRoute
              children={<ListingApplicationsPage />}
              requiresFarmAdmin
              requiresWholesaleContract
            />
          }
        />

        <Route
          path={AdminRoute.LISTINGS}
          element={
            <ProtectedRoute
              children={<ListingsPage />}
              requiresFarmAdmin
              requiresWholesaleContract
            />
          }
        />

        <Route
          path={AdminRoute.LISTING_APPLICATIONS}
          element={
            <ProtectedRoute
              children={<ListingApplicationsPage />}
              requiresAdmin
              requiresWholesaleContract
            />
          }
        />

        <Route
          path={AdminRoute.CHAT}
          element={
            <ProtectedRoute
              children={<ChatPage />}
              requiresFarmAdmin
              ability={permissions.view_partner}
            />
          }
        />

        <Route
          path={AdminRoute.TRANSACTIONS}
          element={
            <ProtectedRoute children={<TransactionListPage />} requiresAdmin />
          }
        />
        <Route
          path={AdminRoute.FARM_TRANSACTIONS}
          element={
            <ProtectedRoute
              children={<FarmOwnerTransactionListPage />}
              requiresFarmAdmin
              ability={permissions.view_transaction}
            />
          }
        />
        <Route
          path={AdminRoute.QMARK}
          element={
            <ProtectedRoute children={<QualityMarkListPage />} requiresAdmin />
          }
        />
        <Route
          path={AdminRoute.COUPONS}
          element={
            <ProtectedRoute children={<CouponsPage />} requiresFarmAdmin />
          }
        />
        <Route
          path={AdminRoute.ESHOP_EMAIL}
          element={
            <ProtectedRoute children={<EShopEmailListPage />} requiresAdmin />
          }
        />
        <Route
          path={AdminRoute.FARM_EMAIL}
          element={
            <ProtectedRoute children={<FarmEmailListPage />} requiresAdmin />
          }
        />
        <Route
          path={AdminRoute.CONTRACTS}
          element={
            <ProtectedRoute children={<ContractListPage />} requiresAdmin />
          }
        />
        <Route
          path={AdminRoute.ORDERS}
          element={
            <ProtectedRoute children={<OrderListPage />} requiresAdmin />
          }
        />
        <Route
          path={AdminRoute.FARMS}
          element={<ProtectedRoute children={<FarmListPage />} requiresAdmin />}
        />
        <Route
          path={AdminRoute.NOTIFICATIONS}
          element={
            <ProtectedRoute
              children={<NotificationListPage />}
              requiresFarmAdmin
            />
          }
        />
        <Route
          path={AdminRoute.FARM_USERS}
          element={
            <ProtectedRoute requiresFarmAdmin children={<FarmUserListPage />} />
          }
        />
        <Route
          path={AdminRoute.FARM_CONTRACTS}
          element={
            <ProtectedRoute children={<FarmContracts />} requiresFarmAdmin />
          }
        />
        <Route
          path={AdminRoute.USERS}
          element={<ProtectedRoute requiresAdmin children={<UserListPage />} />}
        />
        <Route
          path={AdminRoute.PAGES}
          element={<ProtectedRoute children={<Pages />} requiresAdmin />}
        />
        <Route
          path={AdminRoute.PRODUCTS}
          element={<ProtectedRoute children={<Products />} requiresFarmAdmin />}
        />
        <Route
          path={AdminRoute.QUALITY_MARKS}
          element={
            <ProtectedRoute children={<QualityMarksSync />} requiresFarmAdmin />
          }
        />
        <Route
          path={AdminRoute.BANNERS}
          element={<ProtectedRoute requiresAdmin children={<BannersPage />} />}
        />
        <Route
          path={AdminRoute.SETTINGS}
          element={
            <ProtectedRoute requiresAdmin children={<SettingListPage />} />
          }
        />
        <Route
          path={AdminRoute.CATALOG_SETTINGS}
          element={
            <ProtectedRoute requiresAdmin children={<FarmSettingListPage />} />
          }
        />
        <Route
          path={AdminRoute.EMARKET_SETTINGS}
          element={
            <ProtectedRoute
              children={<EmarketSettingListPage />}
              requiresAdmin
            />
          }
        />
        <Route
          path={AdminRoute.BUSINESS}
          element={
            <ProtectedRoute
              children={<BusinessInformation />}
              requiresFarmAdmin
              ability={permissions.view_company}
            />
          }
        />
        <Route
          path={AdminRoute.FARM_DELIVERIES}
          element={
            <ProtectedRoute
              children={<FarmDeliveriesPage />}
              requiresFarmAdmin
            />
          }
        />
        <Route
          path={AdminRoute.PERMISSIONS}
          element={
            <ProtectedRoute requiresAdmin children={<PermissionListPage />} />
          }
        />
        <Route
          path={AdminRoute.CLASSIFIERS}
          element={
            <ProtectedRoute requiresAdmin children={<ClassifiersPage />} />
          }
        />

        <Route path="/*" element={<FarmOwnerTransactionListPage />} />
        <Route path="*" element={<Navigate to={PublicRoute.LOGIN} replace />} />
      </>
    );
  };

  return <Routes>{renderRoutes()}</Routes>;
};

export default Router;
